// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"en_a bhs_a bhs_x bhs_j bhs_u bhs_bc bhs_pp bhs_up"};